export function create_product_mobile_slider({ element, addMargins, parent, selector }) {
	if (!selector) {
		return;
	}

	parent.addClass('splide splide_mobile_slider');

	element.addClass('splide__list').wrap('<div class="splide__track"></div>').find(selector).each(function () {
		jQuery(this).addClass('splide__slide').css('flex', '1 1 clamp( 15.625rem, 18vw, 18.75rem )');
	});

	if (addMargins) {
		parent.find('.splide__track').wrap('<div class="row-margins"></div>');
	}

	let splide = new Splide(parent.get(0), {
		autoWidth: true,
		pagination: false,
		focus: 0,
		omitEnd: true,
		arrowPath: 'm31.9 13.4-1.41 1.41 4.21 4.21h-33.1v2h33.1l-4.21 4.21 1.41 1.41 5.21-5.21 1.42-1.41-1.42-1.41z',
	});

	addArrows(parent);

	splide.on('mounted', () => alignArrows(splide));
	splide.on('overflow', function (isOverflow) {
		splide.options = {
			arrows: isOverflow,
			drag: isOverflow
		}
	});

	window.addEventListener('resize', () => {
		alignArrows(splide);
		maybeMoveArrows(parent);
	}, { passive: true });

	splide.mount();
	splide.event.emit('overflow', splide.Components.Layout.isOverflow())
}

function addArrows(parent) {
	const heading = parent.addClass('splide').find('h2,h3').first();
	const arrows = jQuery('<div class="splide__arrows d-flex gap-1 splide__arrows_inline"></div>');
	_addArrows(heading, parent, arrows);
}

function _addArrows(heading, parent, arrows) {
	if (!arrows) {
		return;
	}

	if (hpyGlobals?.isMobile && heading?.length) {
		heading.append(arrows);
	} else {
		parent.find('.splide__track').append(arrows);
	}
}

function maybeMoveArrows(parent) {
	const heading = parent.addClass('splide').find('h2,h3').first();
	const eleArrows = parent.find('.splide__arrows');
	let arrows = undefined;

	if (eleArrows.length) {
		arrows = eleArrows.detach();
	}

	_addArrows(heading, parent, arrows);
}

function alignArrows(splide) {
	if (hpyGlobals?.isMobile) {
		jQuery(splide.root).addClass('splide__no_max_width').find('h2,h3').first().addClass('d-flex justify-between align-center');
	} else {
		jQuery(splide.root).removeClass('splide__no_max_width').find('h2,h3').first().removeClass('d-flex justify-between align-center');
	}
}

export function validateCommentSubmission() {
	jQuery('#commentform').on('submit', function (e) {
		let valid = true;
		const requiredFields = jQuery('input[required], select[required], textarea[required]');

		if (requiredFields.length > 0) {
			requiredFields.each(function () {
				if (jQuery(this).val() === '') {
					valid = false;
				}
			});
		}

		if (!valid) {
			e.preventDefault();
			jQuery('<div class="woocommerce-error mb-1" role="alert">Please fill out all required fields</div>').insertBefore(jQuery(this));
		}
	});
}